<template lang="pug">
.file-management-wrapper
  h2 gerenciamento de arquivos

  .header(v-if="!adicionandoNovoArquivo")
    .filters(v-if="!ehFuncionario && implementado")
      .associated-users
        PSelect(
          title="usuário associado"
          v-model="termosDaBusca.usuarioAssociado"
          useCommon="users/usuariosQueTemFuncionario"
          labelItem="name"
        )
      .category
        PSelect(
          title="categoria"
          v-model="termosDaBusca.categoria"
          useCommon="reasons/apenasParaGerenciamentoDeArquivo"
          labelItem="description"
          sortAlphabetically
        )
      .upload-date-span
        span data de upload:
      .upload-date-start
        PDatePicker(
          name="dataDeUploadInicio"
          label="de"
          v-model="termosDaBusca.dataDeUpload.inicio"
          buttonSize="md"
        )
      .upload-date-end
        PDatePicker(
          name="dataDeUploadFim"
          label="até"
          v-model="termosDaBusca.dataDeUpload.fim"
          buttonSize="md"
        )
      .botoes
        PButton(color="success" size="md" @click="aplicarBusca" block) buscar
        PButton(color="info" size="md" @click="limpaBusca" block) limpar
    .buttons
      .add-new
        PButton(v-if="temPermissaoParaAdicionarNovo" color="warning" size="md" @click="comecaAdicionarNovoArquivo") novo arquivo

  .upload-new-file(v-else)
    FileManagementDetails(@adicionar="adicionarArquivo" @cancel="cancelaAdicaoDeArquivo")

  .tabela
    SmartTable(
      name="listagem-de-arquivos"
      v-bind="tableConfig"
      v-model="tabela"
      :loadPageFunction="carregarPagina"
      @rowClick="selecionandoArquivo"
      ref="table"
    )
      template(v-slot:default="slotProps")
        TableRow(v-bind="slotProps")
          template(v-slot:dataLimitePedidoUtc="{ columnValue, rowItem, index }")
            span(:title="dateParaString(columnValue)") {{ dateParaString(columnValue) }}
          template(v-slot:situacao="{ columnValue, rowItem, index }")
            .linha
              .icone
                .fs-19.icon-ptt-icons-aprovar.color-success(v-if="columnValue === 'aprovado'")
                .fs-19.icon-ptt-icons-reprovar.color-danger(v-else-if="columnValue === 'rejeitado'")
                .fs-19.icon-ptt-icons-alerta.color-warning(v-else)
              .texto(:title="textoDaSituacao(rowItem)")
                span {{ textoDaSituacao(rowItem) }}

      template(v-slot:detailsBox="{item}")
        Details(
          :item="arquivoSelecionado"
          :loading="carregandoArquivoSelecionado"
          :funcaoDeTextoDaSituacao="textoDaSituacao"
          @updateTable="updateTableAndCloseDetailsBox"
        )
</template>

<script>
import moment from 'moment'
import { mapKeys, pickBy, isEmpty } from 'lodash'

import FileManagementDetails from '../details/FileManagementDetails'
import Details from './Details'

export default {
  name: 'FileManagementList',
  data () {
    return {
      carregandoTabela: false,
      carregandoArquivoSelecionado: false,
      arquivos: [],
      arquivosDepoisDaBusca: undefined,
      arquivoSelecionado: null,
      adicionandoNovoArquivo: false,
      tableConfig: {
        headerItems: [
          {column: 'descricao', field: 'descricao', width: '1fr'},
          {column: 'usuário associado', field: 'usuarioVinculado.email', width: '1fr'},
          {column: 'categoria', field: 'motivo.description', width: '1fr'},
          {column: 'prazo', field: 'dataLimitePedidoUtc', width: '150px'},
          {
            column: 'status',
            field: 'situacao',
            width: '1fr',
            options: [
              {iconClass: 'icon-ptt-icons-alerta', text: 'pendente'},
              {iconClass: 'icon-ptt-icons-aprovar', text: 'aprovado'},
              {iconClass: 'icon-ptt-icons-reprovar', text: 'rejeitado'},
              {iconClass: 'icon-ptt-icons-alerta', text: 'expirado'},
              {iconClass: 'icon-ptt-icons-alerta', text: 'arquivado'},
              {iconClass: 'icon-ptt-icons-alerta', text: 'não arquivado'},
              {iconClass: 'icon-ptt-icons-alerta', text: 'todos'}
            ]
          }
        ],
        config: {
          perPage: 15,
          startFocusedSearch: 'descricao',
          defaultSortField: 'descricao',
          defaultColumnSearch: 'descricao',
          detailsBox: {
            numberColumnsKeep: 1
          }
        }
      },
      termosDaBusca: {
        usuarioAssociado: { selected: null },
        categoria: { selected: null },
        dataDeUpload: {
          inicio: null,
          fim: null
        }
      }
    }
  },
  computed: {
    tabela: {
      get () {
        return {
          loading: this.carregandoTabela,
          loaded: this.arquivosDepoisDaBusca !== undefined
            ? this.arquivosDepoisDaBusca
            : this.arquivos
        }
      }
    },
    ehFuncionario () {
      if (!this.$store.state.userInfo) return true
      return this.$store.state.userInfo.roleGroup.kind === 'mine'
    },
    temPermissaoParaAdicionarNovo () {
      const permDeCriarAprovacaoArquivo = this.$hasPermission({module: 'aprovacaoarquivo', action: 'post'})
      const permDeConsultarMotivosPadrao = this.$hasPermission({module: 'reason', action: 'get'})
      const permDeConsultarUsuarios = this.$hasPermission({module: 'user', action: 'get'})
      return !this.ehFuncionario && permDeCriarAprovacaoArquivo && permDeConsultarMotivosPadrao && permDeConsultarUsuarios
    },
    implementado () {
      return false // Ainda não implementado, então não mostra
    }
  },
  methods: {
    async carregarPagina ({perPage, page, orderBy, search, searchedField, reverse, allSearch}) {
      this.carregandoTabela = true
      this.infoDeArquivoPorId = {}

      const fields = [
        'id', 'descricao', 'usuario_vinculado', 'motivo',
        'data_limite_pedido_utc', 'situacao',
        'situacao_pedidos_individuais', 'data_de_criacao_pedido_utc'
      ]
      const searchType = {
        descricao: 'descricao',
        'usuarioVinculado.email': 'usuario_vinculado',
        'motivo.description': 'motivo',
        dataLimitePedidoUtc: 'data_limite_pedido_utc',
        situacao: 'situacao'
      }

      const pesquisas = mapKeys(allSearch, (_, key) => searchType[key])
      pesquisas.situacao = this.filtroDeSituacao(searchedField, search)
      const pesquisasAtivas = pickBy(pesquisas, value => value !== '')

      let resultado
      try {
        const params = {
          'order_by': searchType[orderBy],
          reverse: reverse,
          fields: JSON.stringify(fields),
          page: page,
          'per_page': perPage
        }
        if (!isEmpty(pesquisasAtivas)) {
          params.search = JSON.stringify(pesquisasAtivas)
        }

        resultado = await this.$API.gerenciamentoDeArquivos.get(params)
        if (resultado.status === 204) {
          resultado = {
            body: {
              success: [],
              total: 0,
              totalPages: 0
            }
          }
        }
      } catch (e) {
        console.error(e)
      }

      this.carregandoTabela = false

      return {
        items: resultado.body.success,
        totalItems: resultado.body.total,
        totalPages: resultado.body.totalPages
      }
    },
    filtroDeSituacao (searchedField, search) {
      if (searchedField !== 'situacao') return 'nao-arquivado'
      if (search === 'todos') return ''
      if (search === 'não arquivado') return 'nao-arquivado'

      return search
    },
    comecaAdicionarNovoArquivo () {
      this.adicionandoNovoArquivo = true
    },
    adicionarArquivo () {
      this.adicionandoNovoArquivo = false
      this.updateTableAndCloseDetailsBox()
    },
    cancelaAdicaoDeArquivo () {
      this.adicionandoNovoArquivo = false
    },
    async selecionandoArquivo (arquivo) {
      this.$set(this, 'arquivoSelecionado', {...arquivo})

      this.carregandoArquivoSelecionado = true

      try {
        const fields = [
          'id', 'descricao', 'usuario_vinculado', 'motivo',
          'data_limite_pedido_utc', 'situacao',
          'situacao_pedidos_individuais', 'data_de_criacao_pedido_utc'
        ]
        const infoCompleta = await this.$API.gerenciamentoDeArquivos.get({
          id: arquivo.id,
          fields: JSON.stringify(fields)
        })
        if (infoCompleta.status === 200) {
          this.$set(this, 'infoDeArquivoPorId', infoCompleta.data.success[0])
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.carregandoArquivoSelecionado = false
      }
      this.$forceUpdate()
    },
    aplicarBusca () {
      const { usuarioAssociado, categoria, dataDeUpload } = this.termosDaBusca

      this.arquivosDepoisDaBusca = this.arquivos.filter(infoDeArquivo => {
        if (usuarioAssociado.selected && usuarioAssociado.selected.id === infoDeArquivo.usuarioVinculado.id) {
          return true
        }

        if (categoria.selected && categoria.selected.id === infoDeArquivo.motivo.id) {
          return true
        }

        if (dataDeUpload.inicio && dataDeUpload.fim) {
          const estaEntreInicioFim = moment(infoDeArquivo.dataDeCriacaoPedidoUtc)
            .isBetween(dataDeUpload.inicio, dataDeUpload.fim)

          if (estaEntreInicioFim) return true
        } else if (dataDeUpload.inicio) {
          const estaDepois = moment(infoDeArquivo.dataDeCriacaoPedidoUtc)
            .isSameOrAfter(dataDeUpload.inicio)

          if (estaDepois) return true
        } else if (dataDeUpload.fim) {
          const estaAntes = moment(infoDeArquivo.dataDeCriacaoPedidoUtc)
            .isSameOrBefore(dataDeUpload.fim)

          if (estaAntes) return true
        }

        return false
      })
    },
    limpaBusca () {
      this.arquivosDepoisDaBusca = undefined
      this.termosDaBusca = {
        usuarioAssociado: { selected: null },
        categoria: { selected: null },
        dataDeUpload: {
          inicio: null,
          fim: null
        }
      }
    },
    dateParaString (date) {
      if (!date) return '-'
      const data = moment(date, 'YYYY-MM-DD')
      return data.format('DD.MM.YYYY')
    },
    textoDaSituacao (linhaDaTabela) {
      const { situacao, situacaoPedidosIndividuais } = linhaDaTabela

      if (situacao === 'aprovado') {
        return 'documento aprovado'
      } else if (situacao === 'rejeitado') {
        return 'documento reprovado'
      } else if (situacao === 'arquivado') {
        return 'documento arquivado'
      }

      let texto = ''

      if (situacao === 'expirado') {
        texto = texto.concat('prazo expirado, ')
      }

      if (situacaoPedidosIndividuais.length > 0) {
        const pendentes = situacaoPedidosIndividuais.filter(p => p.situacao === 'pendente')

        if (pendentes.length > 0) {
          let msg

          if (pendentes.length === 1 && situacao === 'expirado') {
            msg = `1 aprovação pendente`
          } else if (pendentes.length === 1) {
            msg = `aprovação de ${pendentes[0].usuarioQueAprovaraId.name} pendente`
          } else {
            msg = `${pendentes.length} aprovações pendentes`
          }

          texto = texto.concat(msg)
        }
      }

      return texto
    },
    updateTableAndCloseDetailsBox () {
      this.closeDetailsTable()
      this.$refs.table.resetPagesAndReload()
    },
    closeDetailsTable () {
      this.$refs.table.closeDetailsBox()
    }
  },
  components: {FileManagementDetails, Details}
}
</script>

<style lang="scss" scoped>
.file-management-wrapper {
  h2 { text-align: center; }

  .header {
    display: grid;
    // grid-auto-flow: column;
    align-items: end;

    .filters {
      display: grid;
      grid-auto-flow: column;
      column-gap: 10px;
      align-items: end;
      grid-template-columns: minmax(0, 1fr) minmax(0, 1fr) 120px 180px 180px 200px;

      .upload-date-span {
        padding-bottom: 20px;
      }

      .botoes {
        padding-bottom: 12px;
        display: grid;
        grid-auto-flow: column;
        column-gap: 1px;
      }
    }

    .buttons {
      justify-self: end;
      padding-bottom: 12px;
    }
  }

  .tabela {
    margin-top: var(--header-margin-bottom);

    .linha {
      display: flex;

      .icone {
        margin-right: 5px;
      }
      .texto {
        white-space:nowrap;
        overflow-x: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}
</style>
